module.exports = __webpack_public_path__ + "static/media/image_52.f833fafd.png";